module.exports = __webpack_public_path__ + "static/media/cifar10_high_aum.1d188306.csv";